<ng-template #headerEnd>
  <calcite-action scale="m" icon="refresh"
                  text="Refresh" text-enabled
                  (click)="refresh()"/>
</ng-template>

@if (data()) {
  <img [src]="imageUrl()" alt="Aerial view of the subject property" class="subject-location-image" />
} @else if (noMap()) {
  <p class="app-muted">No aerial imagery available for this property.</p>
}
